import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'topo-partial',
  templateUrl: './topo-partial.component.html',
  styleUrls: ['./topo-partial.component.scss']
})
export class TopoPartialComponent implements OnInit {

  constructor() { }

  /**
   * 
   * Init
   * 
   **/
  ngOnInit():void{}

}
